import {Component, OnDestroy, OnInit} from '@angular/core';
import {InformType} from '../../../../global/util/enum/InformType';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DocumentService} from '../../../service/document.service';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {Workflow} from '../../../model/Workflow';
import {DocumentUtil} from '../../../../global/util/DocumentUtil';
import {SignType} from '../../../../global/util/enum/SignType';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Constant} from '../../../../global/util/Constant';
import {AuthService} from '../../../service/auth/auth.service';
import {Router} from '@angular/router';
import {ApplicationService} from '../../../service/application.service';
import {Dialog} from '../../../../global/util/Dialog';
import {TranslateService} from '@ngx-translate/core';
import {WorkflowDataService} from '../../../service/data/workflow-data.service';

@Component({
  selector: 'app-add-document-batch',
  templateUrl: './add-document-batch.component.html',
  styleUrls: ['./add-document-batch.component.css']
})
export class AddDocumentBatchComponent implements OnInit, OnDestroy {
  public loading: boolean;
  public documentForm: FormGroup;
  private arrayProgress: number[] = [];
  private type = 1;
  public fileSelected: boolean;
  public workflows: Workflow[] = [];
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public enterpriseIdSelected: number;
  public title = 'TITLE.ADD-DOCUMENT-BATCH';

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              public documentService: DocumentService,
              public authenticationService: AuthService,
              private modalService: NgbModal,
              private router: Router,
              private applicationService: ApplicationService,
              private workflowDataService: WorkflowDataService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ROLE_PARTNER) || this.hasRole(this.ROLE_ADMIN)) {
      // this.workflows = LocalStorage.getWorkflowsExtraBy(this.enterpriseIdSelected);
      this.workflows = this.workflowDataService.getWorkflows();
    } else {
      this.workflows = LocalStorage.getWorkflowsByPerson();
    }
    // TODO Investigate and improvement pass values by reference and avoid a return of this.workflows
    this.workflows = DocumentUtil.extractOnlyNecesaryWorkflowsBy(this.workflows, SignType.Batch);
    this.createForm();
    const interval = setInterval(() => {
      if (!this.authenticationService.isAuthenticated()) {
        clearInterval(interval);
        this.activeModal.close(InformType.Anything);
      }
    }, 300);
  }

  ngOnDestroy() {
    const items = [
      'others'];
    LocalStorage.removeItems(items);
  }

  /**
   * Carga de documentos en lote anterior.
   */
  // save(): void {
  //     if (this.documentForm.invalid) {
  //         Object.values(this.documentForm.controls).forEach(control => {
  //             control.markAsTouched();
  //         });
  //         return;
  //     }
  //     this.loading = true;
  //     const totalFiles = this.arrayDocument.controls.length;
  //     let completedFiles = 0;
  //     for (let index = 0; index < this.arrayDocument.controls.length; index++) {
  //         const group = this.arrayDocument.controls[index];
  //         if (group instanceof FormGroup) {
  //             const formData = new FormData();
  //             formData.append('type', String(this.type));
  //             formData.append('subject', group.value.subject);
  //             formData.append('files', group.value.file);
  //             formData.append('workflowId', group.value.workflow.id);
  //             formData.append('replacements', '');
  //             formData.append('managements', '');
  //             formData.append('typePersons', '');
  //             formData.append('documents2signByParticipant', JSON.stringify([]));
  //             this.documentService.upload(formData).subscribe((event: HttpEvent<any>) => {
  //                 switch (event.type) {
  //                     case HttpEventType.Sent:
  //                         // TODO When request has been made
  //                         break;
  //                     case HttpEventType.ResponseHeader:
  //                         // TODO When response header has been received
  //                         break;
  //                     case HttpEventType.UploadProgress:
  //                         this.arrayProgress[index] = Math.round(event.loaded / event.total * 100);
  //                         break;
  //                     case HttpEventType.Response:
  //                         completedFiles++;
  //                         if (completedFiles === totalFiles) {
  //                             this.activeModal.close(InformType.Success);
  //                             this.loading = false;
  //                         }
  //                         break;
  //                 }
  //             }, error => {
  //                 this.loading = false;
  //                 // hasError = true;
  //                 // errorMessage = error?.error?.message || 'Error inesperado al subir el documento.';
  //                 if (error.status === HttpStatusCode.NOT_FOUND) {
  //                     this.processError(error);
  //                 } else {
  //                     this.processError(error);
  //                 }
  //             });
  //         }
  //     }
  // const interval = setInterval(() => {
  //   this.loading = true;
  //   let complete = true;
  //   for (const progress of this.arrayProgress) {
  //     if (progress !== 100) {
  //       complete = false;
  //     }
  //   }
  //   if (complete) {
  //     clearInterval(interval);
  //     this.loading = false;
  //     if (!hasError) {
  //       this.activeModal.close(InformType.Success);
  //     } else {
  //       // muestra error en el modal, pero no lo cierra
  //       console.error(errorMessage);
  //     }
  //   }
  // }, 300);
  // }

  /**
   * Se cambio la forma de carga en lote de documentos.
   * Si la carga del documento es exitoso se ira quitando de la lista.
   * SI el documento no es cargago no se elimina en la lista para volver a intentar nuevamente.
   */
  save(): void {
    if (this.documentForm.invalid) {
      Object.values(this.documentForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }

    this.loading = true;
    const totalFiles = this.arrayDocument.controls.length;
    let completedFiles = 0;
    let failedFiles = 0;

    for (let index = 0; index < this.arrayDocument.controls.length; index++) {
      const group = this.arrayDocument.controls[index];
      if (group instanceof FormGroup) {
        const formData = new FormData();
        formData.append('type', String(this.type));
        formData.append('subject', group.value.subject);
        formData.append('files', group.value.file);
        formData.append('workflowId', group.value.workflow.id);
        formData.append('replacements', '');
        formData.append('managements', '');
        formData.append('typePersons', '');
        formData.append('documents2signByParticipant', JSON.stringify([]));

        this.documentService.upload(formData).subscribe({
          next: (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                this.arrayProgress[index] = Math.round(event.loaded / event.total * 100);
                break;
              case HttpEventType.Response:
                // Documento subido con éxito → lo quitamos de la lista
                if (event.status === 200) {
                  const idx = this.arrayDocument.controls.indexOf(group);
                  if (idx > -1) {
                    this.arrayDocument.removeAt(idx);
                  }
                  completedFiles++;
                }
                this.checkIfAllDone(totalFiles, completedFiles, failedFiles);
                break;
            }
          }, error: (err) => {
            failedFiles++;
            group.setErrors({uploadFailed: true}); // marca este doc como fallido
            this.processError(err);
            this.checkIfAllDone(totalFiles, completedFiles, failedFiles);
          }
        });
      }
    }
  }

  checkIfAllDone(total: number, completed: number, failed: number): void {
    if (completed + failed === total) {
      this.loading = false;
      if (failed === 0) {
        // Todos subieron bien → cerrar modal
        this.activeModal.close(InformType.Success);
      } else {
        /**
         *  Al menos uno falló → NO cerrar modal
         *  los fallidos se quedan en la lista para reintentar
         */
      }
    }
  }

  cancel(): void {
    this.activeModal.close();
  }

  private createForm() {
    this.documentForm = this.formBuilder.group(
      {
        arrayDocument: this.formBuilder.array([])
      });
    this.addRow();
  }

  get arrayDocument() {
    return this.documentForm.get('arrayDocument') as FormArray;
  }

  public isInvalidControl(ctrlName: string) {
    return this.documentForm.get(ctrlName).invalid && this.documentForm.get(ctrlName).touched;
  }

  public addRow() {
    const group = this.formBuilder.group({
      subject: ['', [Validators.required]],
      file: [null, [Validators.required]],
      filename: [''],
      workflow: [this.workflows[0]]
    });
    this.arrayDocument.push(group);
    this.arrayProgress.push(0);
  }

  public deleteRow(index: number) {
    this.arrayDocument.removeAt(index);
    this.arrayProgress.splice(index, 1);
  }

  public getProgress(index: number): number {
    return this.arrayProgress[index];
  }

  public changeStatus(event, index: number) {
    const fileSelected = (event.target as HTMLInputElement).files[0];
    if (!fileSelected.name.endsWith('.pdf')) {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.ADD-DOCUMENT-BATCH'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
      return;
    }
    const group = this.arrayDocument.at(index);
    group.patchValue({
      file: fileSelected,
      filename: fileSelected.name
    });
    this.fileSelected = group.get('filename').value;
    group.get('file').updateValueAndValidity();
  }

  get hideDeleteItemOnlyRecord() {
    return this.arrayDocument.length === 1;
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  private processError(error: any) {
    this.title = this.translate.instant('TITLE.ADD-DOCUMENT-BATCH');
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, this.title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
        this.logout();
      } else if (HttpStatusCode.INSUFFICIENT_STORAGE === status) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.LIMIT-STORAGE-EXCEEDED'), this.translate.instant('MESSAGE.LIMIT-STORAGE-EXCEEDED'));
      } else {
        Dialog.show(InformType.Danger, this.title, error.error.message);
      }
    } else {
      Dialog.show(InformType.Danger, this.title, error.error.message);
    }
  }

  private logout() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }
}
